import EventsWebservice from './EventsWebservice';
import { blumarWebserviceAxios } from './HttpHelper';

let axios = blumarWebserviceAxios();

export default class EventService extends EventsWebservice{

	constructor() {
		super('/events');
	}

	getHotels(eventId) {
		return axios.get(`${this.url}/${eventId}/hotels`)
	}

	getTransfers(eventId) {
		return axios.get(`${this.url}/${eventId}/transfers`)
	}

	getTours(eventId) {
		return axios.get(`${this.url}/${eventId}/tours`)
	}

	getAllAvaliable() {
		return axios.get(`${this.url}/calendar`);
	}

	getAllDefinitive() {
		return axios.get(`${this.url}/resume`);
	}

	getByShortName(shortName) {
		return axios.get(`${this.url}/name/${shortName}`)
	}

	sendFlightReservation(eventId, flightRequest) {
		return axios.post(`${this.url}/${eventId}/flights`, flightRequest);
	}

	sendPrePostTourRequest(eventId, request) {
		return axios.post(`${this.url}/${eventId}/pre-post-tour-requests`, request);
	}

	sendConfirmationErrorEmail(eventId, errorConfirmationRequest) {
		return axios.post(`${this.url}/${eventId}/alert-reservation-error`, errorConfirmationRequest);
	}

	sendLogin(login) {
		return axios.post(`${this.url}/login`, login);
	}
}



// WEBPACK FOOTER //
// ./src/services/EventService.js